// -----------------------------------------------------------------------------
// UTIL/SELECTION
// -----------------------------------------------------------------------------
import { NodeSelection } from "prosemirror-state";
// -----------------------------------------------------------------------------
export function markActive(type) {
    return (state) => {
        const { from, $from, to, empty } = state.selection;
        if (empty) {
            return type.isInSet(state.storedMarks || $from.marks()) && true;
        }
        else {
            return state.doc.rangeHasMark(from, to, type);
        }
    };
}
export function innerBlockActive(type, attrs) {
    return (state) => {
        const { $from, $to } = state.selection;
        if ($from.parent.type === type && $to.parent.type === type) {
            for (let attr in attrs) {
                if ($from.parent.attrs[attr] !== attrs[attr]) {
                    return false;
                }
                if ($to.parent.attrs[attr] !== attrs[attr]) {
                    return false;
                }
            }
            return true;
        }
        else {
            return false;
        }
        ;
    };
}
export function outerBlockActive(type, attrs) {
    return (state) => {
        const { $from, $to } = state.selection;
        const depth = $from.depth;
        for (let i = depth; i > 0; i--) {
            if ($from.node(i) && $to.node(i)
                && $from.node(i).type == type
                && $to.node(i).type == type
                && $from.node(i) == $to.node(i)) {
                for (let attr in attrs) {
                    if ($from.node(i).attrs[attr] !== attrs[attr]) {
                        return false;
                    }
                }
                return true;
            }
            ;
        }
        return false;
    };
}
export function leafActive(nodeType) {
    return (state) => {
        if (state.selection instanceof NodeSelection) {
            return state.selection.node.type === nodeType;
        }
        else {
            return false;
        }
    };
}
